import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import DashboardLayout from "../../../UI/Layout/DashboardLayout";
import Title from "../../../UI/Text/Title";
import axios from "axios";

const AgentBillingList = () => {
    const { name } = useParams();
    const history = useHistory();
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage?.user?.userId;
    const token = lStorage?.token;

    const [agent, setAgent] = useState("");
    const [autoRenew, setAutoRenew] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchAgent = async () => {
            try {
                const response = await axios.post("https://stagnapi.authkey.io/api/agent_management", {
                    user_id,
                    token,
                    method: "agent_list",
                });

                const agents = response.data?.data;
                const selectedAgent = agents?.find((a) => a.name === name);

                if (selectedAgent) {
                    setAgent(selectedAgent);
                    setAutoRenew(selectedAgent.auto_renew_status === 1 ? "Yes" : "No");
                    setStatus(selectedAgent.is_active === 1 ? "Active" : "Inactive");
                } else {
                    setError("Agent not found.");
                }
            } catch (err) {
                console.error(err);
                setError("Error fetching agent data.");
            }
        };

        fetchAgent();
    }, [name, user_id, token]);

    const handleSave = async () => {
        try {
            const response = await axios.post("https://stagnapi.authkey.io/api/agent_management", {
                user_id,
                token,
                method: "edit_setting",
                agent_name: agent.name,
                auto_renew_status: autoRenew === "Yes" ? 1 : 0,
                is_active: status === "Active" ? 1 : 0,
            });

            if (response.data.success) {
               history.push("/dashboard/agent-billing");
            } else {
                setError(response.data.message || "Update failed.");
            }
        } catch (err) {
            console.error(err);
            setError("Error updating agent.");
        }
    };



    return (
        <DashboardLayout>
            <main className="content">
                <div className="container-fluid p-0">
                    <Title>Agent Billing Edit</Title>
                    {error && <p style={{ color: "red" }}>{error}</p>}

                    {agent ? (
                        <div className="card p-3">
                            <div className="mb-3">
                                <label>Agent Name</label>
                                <input className="form-control" value={agent.name} readOnly />
                            </div>

                            <div className="mb-3">
                                <label>Created</label>
                                <input className="form-control" value={agent.Created} readOnly />
                            </div>

                            <div className="mb-3">
                                <label>Expiry Date</label>
                                <input className="form-control" value={agent.Expiry_Date} readOnly />
                            </div>

                            <div className="mb-3">
                                <label>Auto Renew Status</label>
                                <select
                                    className="form-control"
                                    value={autoRenew}
                                    onChange={(e) => setAutoRenew(e.target.value)}
                                >
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                    ) : (
                        !error && <p>Loading agent data...</p>
                    )}
                </div>
                <div className="text-end">
                    <button onClick={handleSave} className="btn btn-primary mt-3">
                        Update
                    </button>
                </div>

            </main>


        </DashboardLayout>
    );
};

export default AgentBillingList;
